<template>
  <head>

    <meta charset="utf-8"/>
    <title>Bill</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Keep your finances and membership up to date" name="description"/>
    <meta content="" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.svg" rel="shortcut icon">

    <!-- Bootstrap Css -->
    <link id="bootstrap-style" href="assets/css/bootstrap.min.css" rel="stylesheet" type="text/css"/>
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link id="app-style" href="assets/css/app.min.css" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link id="app-style" href="assets/css/custom.css" rel="stylesheet" type="text/css"/>


  </head>
  <!--  @contextmenu.prevent-->
  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <Navigation/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <!-- Start Page-content -->
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Dashboard</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- some stats -->
          <div class="row">
            <!-- Total Employees -->
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Establishment</p>
                      <h4 class="mb-0">{{ metrics.totalEmployees }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="avatar-sm rounded-circle bg-success mini-stat-icon">
                      <span class="avatar-title rounded-circle bg-success">
                        <i class="bx bx-group font-size-24"></i>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Employees Added This Month -->
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Employees Added (This Month)</p>
                      <h4 class="mb-0">{{ metrics.employeesAddedThisMonth }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="avatar-sm rounded-circle bg-info mini-stat-icon">
                      <span class="avatar-title rounded-circle bg-info">
                        <i class="bx bx-user-plus font-size-24"></i>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- Employees Absent Without Permission -->
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Absent Without Permission</p>
                      <h4 class="mb-0">{{ metrics.absentWithoutPermission }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="avatar-sm rounded-circle bg-danger mini-stat-icon">
                      <span class="avatar-title rounded-circle bg-danger">
                        <i class="bx bx-user-x font-size-24"></i>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- Employees Absent Without Permission -->
            <div class="col-md-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Absent With Permission</p>
                      <h4 class="mb-0">{{ metrics.absentWithPermission }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="avatar-sm rounded-circle bg-danger mini-stat-icon">
                      <span class="avatar-title rounded-circle bg-danger">
                        <i class="bx bx-user-x font-size-24"></i>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
          <!-- end of stats -->

          <!-- quick stats -->
          <div class="row">

            <div class="col-sm-12 col-md-4 col-lg-4">
              <div class="card">
                <div class="card-header bg-transparent border-bottom border-succes">
                  <div class="d-sm-flex flex-wrap">
                    <h4 class="card-title text-black text-uppercase">Live Monitoring</h4>
                    <div class="ms-auto">
                      <ul class="nav nav-pills text-uppercase d-none">
                        <li class="nav-item">
                          <a class="nav-link active" href="javascript:void(0);">Week</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="javascript:void(0);">Month</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="javascript:void(0);">Year</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div id="map" dir="ltr" style="height: 400px"/>
                </div>
              </div>
            </div>



            <div class="col-sm-12 col-md-4 col-lg-4">
              <div class="card">
                <div class="card-header bg-transparent border-bottom border-succes">
                  <div class="d-sm-flex flex-wrap">
                    <h4 class="card-title text-black text-uppercase">Attendance Summary for This Year</h4>
                    <div class="ms-auto">
                      <ul class="nav nav-pills text-uppercase d-none">
                        <li class="nav-item">
                          <a class="nav-link active" href="javascript:void(0);">Week</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="javascript:void(0);">Month</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="javascript:void(0);">Year</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div id="AttendanceContainer"></div>
                </div>
              </div>
            </div>


            <div class="col-xl-4 col-md-5 col-lg-4 px-sm-30px">
              <div class="card member-wedges-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="d-flex flex-wrap align-items-start">
                      <h5 class="mb-3 me-2 text-black">Employee attendance for Today</h5>
                    </div>
                    <div class="ms-auto align-self-end position-absolute d-none">
                      <i class="mdi mdi-block-helper display-4 opacity-50"></i>
                    </div>
                  </div>
                  <div id="TodayAttendanceContainer"></div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex flex-wrap align-items-start">
                    <h5 class="mb-3 me-2 text-black">Staff Turnover by Department Feb 2025</h5>
                  </div>
                </div>
                <div class="card-body">
                  <div id="NewContainer"></div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex flex-wrap align-items-start">
                    <h5 class="mb-3 me-2 text-black">Nature Of Exits</h5>
                  </div>
                </div>
                <div class="card-body">
                  <div id="ExitChart"></div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex flex-wrap align-items-start">
                    <h5 class="mb-3 me-2 text-black">Nature of Entries</h5>
                  </div>
                </div>
                <div class="card-body">
                  <div id="EntryChart"></div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex flex-wrap align-items-start">
                    <h5 class="mb-3 me-2 text-black">Gender Comparissons</h5>
                  </div>
                </div>
                <div class="card-body">
                  <div id="GenderContainer"></div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex flex-wrap align-items-start">
                    <h5 class="mb-3 me-2 text-black">Distribution of Employees with Disabilities</h5>
                  </div>
                </div>
                <div class="card-body">
                  <div id="disabilityChart"></div>
                </div>
              </div>
            </div>



          </div>
          <!-- end of quick stats -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              {{ currentYear }} © Best Birdy
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">

              </div>
            </div>
          </div>
        </div>
      </footer>

      <!-- End Page-content -->

    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>


  </body>
</template>

<script>
/* eslint-disable */
import Navigation from "@/components/Navigation.vue";
import Highcharts from 'highcharts';

// Load modules directly via import - no initialization needed
import 'highcharts/modules/drilldown';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/accessibility';
import {authUrl, execute} from "@/api";
import {loadScript} from "vue-plugin-load-script";

// Set default global options for Highcharts to use a safe locale
Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
    decimalPoint: '.'
  }
});

export default {
  name: "dashboard",
  components: {Navigation},
  data() {
    return {
      useMockData: false,

      currentYear: new Date().getFullYear(),

      metrics: {
        totalEmployees: "10",
        employeesAddedThisMonth: "2",
        absentWithoutPermission: "10",
        absentWithPermission: "0",
        absentWithoutPermissionRate: 100,
        absentWithPermissionRate: 0,
        newEmployeeRate: 20
      },

      attendanceData: null,
      todayAttendanceData: null,

      staffTurnoverData: null,
      selectedYearMonth: new Date().toISOString().slice(0, 7), // Default to current year-month
      currentMonth: new Date().toLocaleString('default', {month: 'short'}),

      natureOfExitData: null,
      natureOfEntryData: null,
      genderComparisonData: null,
      disabilityDistribution: null,
    }
  },
  mounted() {


    // Allow some time for DOM to be ready
    /*  this.$nextTick(() => {
        this.initializeCharts()

      });
  */
    this.getEmployeeMetrics()
    this.getAttendanceSummary()


    this.getTodayAttendance()
    this.getStaffTurnover()
    this.getNatureOfExits()
    this.getNatureOfEntries()
    this.getGenderComparison()
    this.getDisabilityDistribution()
    this.getEmployeesMap()

    loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyBl3dCvpVQUs04SOTCHgITw4Ts79-dRcfI&callback=initMap')

  },
  methods: {

    getEmployeesMap() {
      const data = new FormData();
      data.append("function", "getEmployeesMap");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              this.initMap()
            } else {

            }
          })
          .catch((e) => {
            console.error("Error fetching staff turnover data:", e);
            // Optionally show an error message to the user
          });
    },

    initMap() {
      // Default center coordinates for Nairobi
      const latitude = parseFloat('-1.2691307511790206');
      const longitude = parseFloat('36.79803175971192');

      const success = (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        // Do something with the position
      };

      const error = (err) => {
        console.log(err);
      };

      // This will open permission popup
      navigator.geolocation.getCurrentPosition(success, error);

      let map;
      map = new google.maps.Map(document.getElementById("map"), {
        zoom: 13,
        center: {lat: latitude, lng: longitude}, // Default center (Nairobi)
      });

      // Use the employee data from the API response
      const data = new FormData();
      data.append("function", "getEmployeesMap");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              const employees = res.data.data.employees;

              employees.forEach((employee) => {
                // Check if latitude and longitude values exist and are valid
                if (employee.lat && employee.lng) {
                  const position = {
                    lat: parseFloat(employee.lat),
                    lng: parseFloat(employee.lng)
                  };

                  // Skip invalid coordinates
                  if (isNaN(position.lat) || isNaN(position.lng)) {
                    console.warn("Invalid coordinates for employee:", employee);
                    return;
                  }

                  // Create marker for each employee
                  const marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    title: `${employee.firstName} ${employee.lastName}`
                  });

                  // Create info window with employee details
                  const fullName = `${employee.firstName} ${employee.middleName || ''} ${employee.lastName}`.trim();
                  const infowindow = new google.maps.InfoWindow({
                    content: `<div>
                <h6 class="text-capitalize">${fullName}</h6>
                <p>Location: ${position.lat.toFixed(6)}, ${position.lng.toFixed(6)}</p>
              </div>`
                  });

                  // Set default marker icon - can be customized based on employee data
                  const employeeIcon = {
                    url: "assets/images/users/active-agent.png",
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(19, 40)
                  };

                  marker.setIcon(employeeIcon);

                  // Add event listeners for marker interactions
                  marker.addListener("mouseover", () => {
                    infowindow.open(map, marker);
                  });

                  marker.addListener("mouseout", () => {
                    infowindow.close();
                  });
                }
              });
            } else {
              console.error("Failed to fetch employee map data:", res.data.message);
            }
          })
          .catch((e) => {
            console.error("Error fetching employee map data:", e);
          });
    },

    initializeCharts() {
      // Helper function to generate daily data for attendance chart
      const generateDailyData = (daysInMonth, ratio) => {
        const data = [];
        for (let day = 1; day <= daysInMonth; day++) {
          data.push([String(day), Math.round(7720 * ratio)]);
        }
        return data;
      };

      // Attendance Summary Chart
      if (document.getElementById('AttendanceContainer')) {
        Highcharts.chart('AttendanceContainer', {
          chart: {
            type: 'column'
          },
          title: {
            text: null
          },
          xAxis: {
            type: 'category',
            labels: {
              rotation: -90,
              align: 'right',
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Total Days'
            },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
              },
              formatter: function () {
                return Highcharts.numberFormat(this.total, 0, '.', ',');
              }
            }
          },
          legend: {
            align: 'center',
            verticalAlign: 'bottom',
            floating: false,
            backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || 'white',
            borderColor: '#CCC',
            borderWidth: 1,
            shadow: false
          },
          tooltip: {
            headerFormat: '<b>Attendance Report For {point.key}</b><br/> ',
            pointFormatter: function () {
              const present = this.series.chart.series[0].data[this.index].y;
              const absent = this.series.chart.series[1].data[this.index].y;
              const total = present + absent;
              return '<span style="font-weight: 600; color: #0caf60;">Present:</span> ' +
                  Highcharts.numberFormat(present, 0, '.', ',') +
                  '<br/>' +
                  '<span style="font-weight: 600; color: #ff3a6e;">Absent:</span> ' +
                  Highcharts.numberFormat(absent, 0, '.', ',') + '<br/>' +
                  '<span style="font-weight: 600;">Total:</span> ' +
                  Highcharts.numberFormat(total, 0, '.', ',');
            }
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                rotation: -90,
                align: 'right',
                verticalAlign: 'middle',
                y: 10,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 0, '.', ',');
                }
              }
            }
          },
          series: [{
            name: 'Present',
            color: '#0caf60',
            data: [
              {name: 'JAN', y: 6200, drilldown: 'January-Attendance'},
              {name: 'FEB', y: 7480, drilldown: 'February-Attendance'},
              {name: 'MAR', y: 7450, drilldown: 'March-Attendance'},
              {name: 'APR', y: 7400, drilldown: 'April-Attendance'},
              {name: 'MAY', y: 7350, drilldown: 'May-Attendance'},
              {name: 'JUN', y: 7300, drilldown: 'June-Attendance'},
              {name: 'JUL', y: 7200, drilldown: 'July-Attendance'},
              {name: 'AUG', y: 7100, drilldown: 'August-Attendance'},
              {name: 'SEP', y: 6950, drilldown: 'September-Attendance'},
              {name: 'OCT', y: 6700, drilldown: 'October-Attendance'},
              {name: 'NOV', y: 6400, drilldown: 'November-Attendance'},
              {name: 'DEC', y: 6000, drilldown: 'December-Attendance'}
            ]
          }, {
            name: 'Absent',
            color: '#ff3a6e',
            data: [
              {name: 'JAN', y: 1820, drilldown: 'January-Absenteeism'},
              {name: 'FEB', y: 240, drilldown: 'February-Absenteeism'},
              {name: 'MAR', y: 270, drilldown: 'March-Absenteeism'},
              {name: 'APR', y: 320, drilldown: 'April-Absenteeism'},
              {name: 'MAY', y: 370, drilldown: 'May-Absenteeism'},
              {name: 'JUN', y: 420, drilldown: 'June-Absenteeism'},
              {name: 'JUL', y: 520, drilldown: 'July-Absenteeism'},
              {name: 'AUG', y: 620, drilldown: 'August-Absenteeism'},
              {name: 'SEP', y: 770, drilldown: 'September-Absenteeism'},
              {name: 'OCT', y: 1020, drilldown: 'October-Absenteeism'},
              {name: 'NOV', y: 1320, drilldown: 'November-Absenteeism'},
              {name: 'DEC', y: 1720, drilldown: 'December-Absenteeism'}
            ]
          }],
          drilldown: {
            series: [
              {
                id: 'January-Attendance',
                name: 'Attendance Data for January',
                data: generateDailyData(31, 0.95)
              },
              {
                id: 'January-Absenteeism',
                name: 'Absenteeism Data for January',
                data: generateDailyData(31, 0.05)
              },
              // Add other months as needed
            ]
          }
        });
      }

      // Gender Comparison Chart
      if (document.getElementById('GenderContainer')) {
        Highcharts.chart('GenderContainer', {
          chart: {
            type: 'pie'
          },
          title: {
            text: null
          },
          subtitle: {
            text: 'Click the slices to view department distribution.'
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          plotOptions: {
            series: {
              borderRadius: 5,
              dataLabels: [
                {
                  enabled: true,
                  distance: 15,
                  format: '{point.name}: {point.y}'
                },
                {
                  enabled: true,
                  distance: '-30%',
                  filter: {
                    property: 'percentage',
                    operator: '>',
                    value: 5
                  },
                  format: '{point.y}',
                  style: {
                    fontSize: '0.9em',
                    textOutline: 'none'
                  }
                }
              ]
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: ' +
                '<b>{point.y} of {point.total}</b><br/>'
          },
          series: [
            {
              name: 'Gender',
              colorByPoint: true,
              data: [
                {
                  name: 'Male',
                  y: 4620,
                  drilldown: 'Male',
                  total: 4620
                },
                {
                  name: 'Female',
                  y: 3100,
                  drilldown: 'Female',
                  total: 3100
                }
              ]
            }
          ],
          drilldown: {
            series: [
              {
                name: 'Male Employees',
                id: 'Male',
                data: [
                  ['Health Services', 1500],
                  ['Education & ICT', 1200],
                  ['Finance & Economic Planning', 650],
                  ['Agriculture, Livestock & Fisheries', 500],
                  ['Transport & Infrastructure', 420],
                  ['Trade, Industry & Cooperatives', 250],
                  ['Other', 100]
                ]
              },
              {
                name: 'Female Employees',
                id: 'Female',
                data: [
                  ['Health Services', 1250],
                  ['Education & ICT', 950],
                  ['Finance & Economic Planning', 500],
                  ['Agriculture, Livestock & Fisheries', 200],
                  ['Transport & Infrastructure', 150],
                  ['Trade, Industry & Cooperatives', 50],
                  ['Other', 100]
                ]
              }
            ]
          }
        });
      }


      // Staff Turnover Chart
      if (document.getElementById('NewContainer')) {
        Highcharts.chart('NewContainer', {
          chart: {
            type: 'bar'
          },
          title: {
            text: null
          },
          subtitle: {
            text: 'Comparison of new hires and exits across departments'
          },
          xAxis: {
            categories: [
              'Health Services',
              'Education & ICT',
              'Finance & Economic Planning',
              'Agriculture, Livestock & Fisheries',
              'Transport & Infrastructure',
              'Trade, Industry & Cooperatives',
              'Other'
            ],
            title: {
              text: 'Departments'
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Number of Employees'
            }
          },
          legend: {
            enabled: true
          },
          tooltip: {
            shared: true,
            pointFormat: '<b>{series.name}: {point.y}</b>'
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 0, '.', ',');
                }
              },
              stacking: 'normal'
            }
          },
          series: [{
            name: 'New Hires',
            data: [12, 10, 8, 7, 6, 5, 5],
            color: '#33FF57'
          }, {
            name: 'Exits',
            data: [3, 2, 2, 2, 2, 1, 1],
            color: '#FF5733'
          }],
          caption: {
            text: '<div style="text-align: right; font-size: 16px; font-weight: bold; color: #000;">Total New Hires: 53 | Total Exits: 13</div>',
            useHTML: true
          }
        });
      }

      // Exit Chart
      if (document.getElementById('ExitChart')) {
        Highcharts.chart('ExitChart', {
          chart: {
            type: 'pie'
          },
          title: {
            text: 'Nature of Exits'
          },
          subtitle: {
            text: 'Click on a category to view department-wise breakdown'
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y}'
              }
            }
          },
          series: [{
            name: 'Exits',
            colorByPoint: true,
            data: [
              {
                name: 'Death',
                y: 1,
                drilldown: 'death'
              },
              {
                name: 'Dismissal',
                y: 4,
                drilldown: 'dismissal'
              },
              {
                name: 'Resignation',
                y: 5,
                drilldown: 'resignation'
              },
              {
                name: 'Transfers',
                y: 2,
                drilldown: 'transfers'
              },
              {
                name: 'Other',
                y: 1,
                drilldown: 'other'
              }
            ]
          }],
          drilldown: {
            series: [
              {
                id: 'death',
                name: 'Death - Department Breakdown',
                data: [
                  ['Health Services', 1]
                ]
              },
              {
                id: 'dismissal',
                name: 'Dismissal - Department Breakdown',
                data: [
                  ['Health Services', 1],
                  ['Education & ICT', 1],
                  ['Finance & Economic Planning', 1],
                  ['Agriculture, Livestock & Fisheries', 1]
                ]
              },
              {
                id: 'resignation',
                name: 'Resignation - Department Breakdown',
                data: [
                  ['Health Services', 2],
                  ['Education & ICT', 1],
                  ['Finance & Economic Planning', 1],
                  ['Agriculture, Livestock & Fisheries', 1]
                ]
              },
              {
                id: 'transfers',
                name: 'Transfers - Department Breakdown',
                data: [
                  ['Health Services', 1],
                  ['Education & ICT', 1]
                ]
              },
              {
                id: 'other',
                name: 'Other - Department Breakdown',
                data: [
                  ['Health Services', 1]
                ]
              }
            ]
          }
        });
      }

      // Entry Chart
      if (document.getElementById('EntryChart')) {
        Highcharts.chart('EntryChart', {
          chart: {
            type: 'pie'
          },
          title: {
            text: 'Nature of New Hires'
          },
          subtitle: {
            text: 'Click on a category to view department-wise breakdown'
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y}'
              }
            }
          },
          series: [{
            name: 'New Hires',
            colorByPoint: true,
            data: [
              {
                name: 'Direct Recruitment',
                y: 30,
                drilldown: 'direct'
              },
              {
                name: 'Transfers In',
                y: 10,
                drilldown: 'transfers_in'
              },
              {
                name: 'Rehired',
                y: 8,
                drilldown: 'rehired'
              },
              {
                name: 'Other',
                y: 5,
                drilldown: 'other'
              }
            ]
          }],
          drilldown: {
            series: [
              {
                id: 'direct',
                name: 'Direct Recruitment - Department Breakdown',
                data: [
                  ['Health Services', 10],
                  ['Education & ICT', 8],
                  ['Finance & Economic Planning', 5],
                  ['Agriculture, Livestock & Fisheries', 3],
                  ['Transport & Infrastructure', 2],
                  ['Trade, Industry & Cooperatives', 1],
                  ['Other', 1]
                ]
              },
              {
                id: 'transfers_in',
                name: 'Transfers In - Department Breakdown',
                data: [
                  ['Health Services', 3],
                  ['Education & ICT', 2],
                  ['Finance & Economic Planning', 2],
                  ['Agriculture, Livestock & Fisheries', 1],
                  ['Transport & Infrastructure', 1],
                  ['Trade, Industry & Cooperatives', 1]
                ]
              },
              {
                id: 'rehired',
                name: 'Rehired - Department Breakdown',
                data: [
                  ['Health Services', 3],
                  ['Education & ICT', 2],
                  ['Finance & Economic Planning', 2],
                  ['Agriculture, Livestock & Fisheries', 1]
                ]
              },
              {
                id: 'other',
                name: 'Other - Department Breakdown',
                data: [
                  ['Health Services', 2],
                  ['Education & ICT', 1],
                  ['Finance & Economic Planning', 1],
                  ['Agriculture, Livestock & Fisheries', 1]
                ]
              }
            ]
          }
        });
      }

      // Disability Chart
      if (document.getElementById('disabilityChart')) {
        Highcharts.chart('disabilityChart', {
          chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false
          },
          title: {
            text: null
          },
          subtitle: {
            text: 'Click to see department-wise distribution'
          },
          accessibility: {
            point: {
              valueSuffix: ''
            }
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y} ({point.percentage:.1f}%)'
              },
              startAngle: -90,
              endAngle: 90,
              center: ['50%', '75%'],
              size: '110%'
            }
          },
          series: [{
            name: 'Gender',
            colorByPoint: true,
            innerSize: '50%',
            data: [
              {
                name: 'Male',
                y: 35,
                drilldown: 'male'
              },
              {
                name: 'Female',
                y: 24,
                drilldown: 'female'
              }
            ]
          }],
          drilldown: {
            series: [
              {
                id: 'male',
                name: 'Male Employees with Disabilities - Department Breakdown',
                dataLabels: {
                  format: '{point.name}: {point.y} ({point.percentage:.1f}%)'
                },
                data: [
                  ['Health Services', 10],
                  ['Education & ICT', 6],
                  ['Finance & Economic Planning', 5],
                  ['Agriculture, Livestock & Fisheries', 4],
                  ['Transport & Infrastructure', 4],
                  ['Trade, Industry & Cooperatives', 3],
                  ['Other', 3]
                ]
              },
              {
                id: 'female',
                name: 'Female Employees with Disabilities - Department Breakdown',
                dataLabels: {
                  format: '{point.name}: {point.y} ({point.percentage:.1f}%)'
                },
                data: [
                  ['Health Services', 8],
                  ['Education & ICT', 4],
                  ['Finance & Economic Planning', 3],
                  ['Agriculture, Livestock & Fisheries', 2],
                  ['Transport & Infrastructure', 3],
                  ['Trade, Industry & Cooperatives', 2],
                  ['Other', 2]
                ]
              }
            ]
          }
        });
      }
    },
    getEmployeeMetrics() {
      const data = new FormData();
      data.append("function", "getEmployeeMetrics");
      execute(data, authUrl)
          .then((res) => {

            if (res.data.success) {
              this.metrics = res.data.data.metrics;
            } else {
            }
          })
          .catch((e) => {
          })
    },

    //Attendance Summary for This Year
    getAttendanceSummary() {
      const data = new FormData();
      data.append("function", "getAttendanceSummary");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              // Store the API response data - the actual data is nested one level deeper!
              this.attendanceData = res.data.data;  // FIXED: Access the nested data property
              console.log("API data stored correctly:", this.attendanceData);
              this.renderAttendanceChart();
            } else {
              console.error("Failed to fetch attendance data:", res.data.message);
              this.renderAttendanceChart();
            }
          })
          .catch((e) => {
            console.error("Error fetching attendance data:", e);
            this.renderAttendanceChart();
          });
    },
    renderAttendanceChart() {
      // Default data for chart in case API fails
      const defaultData = {
        present: [
          {name: 'JAN', y: 6200, drilldown: 'January-Attendance'},
          {name: 'FEB', y: 7480, drilldown: 'February-Attendance'},
          {name: 'MAR', y: 7450, drilldown: 'March-Attendance'},
          {name: 'APR', y: 7400, drilldown: 'April-Attendance'},
          {name: 'MAY', y: 7350, drilldown: 'May-Attendance'},
          {name: 'JUN', y: 7300, drilldown: 'June-Attendance'},
          {name: 'JUL', y: 7200, drilldown: 'July-Attendance'},
          {name: 'AUG', y: 7100, drilldown: 'August-Attendance'},
          {name: 'SEP', y: 6950, drilldown: 'September-Attendance'},
          {name: 'OCT', y: 6700, drilldown: 'October-Attendance'},
          {name: 'NOV', y: 6400, drilldown: 'November-Attendance'},
          {name: 'DEC', y: 6000, drilldown: 'December-Attendance'}
        ],
        absent: [
          {name: 'JAN', y: 1820, drilldown: 'January-Absenteeism'},
          {name: 'FEB', y: 240, drilldown: 'February-Absenteeism'},
          {name: 'MAR', y: 270, drilldown: 'March-Absenteeism'},
          {name: 'APR', y: 320, drilldown: 'April-Absenteeism'},
          {name: 'MAY', y: 370, drilldown: 'May-Absenteeism'},
          {name: 'JUN', y: 420, drilldown: 'June-Absenteeism'},
          {name: 'JUL', y: 520, drilldown: 'July-Absenteeism'},
          {name: 'AUG', y: 620, drilldown: 'August-Absenteeism'},
          {name: 'SEP', y: 770, drilldown: 'September-Absenteeism'},
          {name: 'OCT', y: 1020, drilldown: 'October-Absenteeism'},
          {name: 'NOV', y: 1320, drilldown: 'November-Absenteeism'},
          {name: 'DEC', y: 1720, drilldown: 'December-Absenteeism'}
        ]
      };

      // Generate drill-down data for daily view (safely)
      const generateDailyData = (monthIndex, isPresent) => {
        const data = [];
        // Map month index to actual days in month
        const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        const daysInMonth = daysInMonths[monthIndex];

        // Default employee count
        const defaultEmployeeCount = 7720;

        // Set ratio based on attendance type (95% present, 5% absent as default)
        const ratio = isPresent ? 0.95 : 0.05;

        for (let day = 1; day <= daysInMonth; day++) {
          data.push([String(day), Math.round(defaultEmployeeCount * ratio)]);
        }
        return data;
      };

      // Attendance Summary Chart
      if (document.getElementById('AttendanceContainer')) {
        // Create drill-down series for all months
        const drilldownSeries = [];
        const months = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'];

        // Generate drill-down data for each month
        months.forEach((month, index) => {
          drilldownSeries.push({
            id: `${month}-Attendance`,
            name: `Attendance Data for ${month}`,
            data: generateDailyData(index, true)
          });

          drilldownSeries.push({
            id: `${month}-Absenteeism`,
            name: `Absenteeism Data for ${month}`,
            data: generateDailyData(index, false)
          });
        });

        // Determine which data to use (API or default)
        let presentData = [...defaultData.present]; // Create a copy to avoid mutation
        let absentData = [...defaultData.absent];   // Create a copy to avoid mutation

        console.log("Using API data:", !!this.attendanceData);

        if (this.attendanceData && this.attendanceData.chartData) {
          // Now we have the correct nested data structure
          if (this.attendanceData.chartData.series &&
              Array.isArray(this.attendanceData.chartData.series) &&
              this.attendanceData.chartData.series.length >= 2) {

            // Access the correctly nested API data
            const apiPresentData = this.attendanceData.chartData.series[0].data;
            const apiAbsentData = this.attendanceData.chartData.series[1].data;

            if (Array.isArray(apiPresentData) && apiPresentData.length === 12) {
              console.log("Using API present data", apiPresentData);
              presentData = apiPresentData;
            }

            if (Array.isArray(apiAbsentData) && apiAbsentData.length === 12) {
              console.log("Using API absent data", apiAbsentData);
              absentData = apiAbsentData;
            }
          }
        } else {
          console.log("API data not available or not in expected format, using default data");
        }

        // Check if the data contains actual numbers greater than zero
        const hasRealData = presentData.some(item => item.y > 0) || absentData.some(item => item.y > 0);
        console.log("Has real attendance data:", hasRealData);

        // If no real data, use mock data for visualization
        if (!hasRealData && !this.useMockData) {
          console.log("No actual attendance data found - using default demo data for visualization");
          presentData = defaultData.present;
          absentData = defaultData.absent;
        }

        console.log("Final Present Data for Chart:", presentData);
        console.log("Final Absent Data for Chart:", absentData);

        Highcharts.chart('AttendanceContainer', {
          chart: {
            type: 'column'
          },
          title: {
            text: null
          },
          xAxis: {
            type: 'category',
            labels: {
              rotation: -90,
              align: 'right',
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Total Days'
            },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
              },
              formatter: function () {
                return Highcharts.numberFormat(this.total, 0, '.', ',');
              }
            }
          },
          legend: {
            align: 'center',
            verticalAlign: 'bottom',
            floating: false,
            backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || 'white',
            borderColor: '#CCC',
            borderWidth: 1,
            shadow: false
          },
          tooltip: {
            headerFormat: '<b>Attendance Report For {point.key}</b><br/> ',
            pointFormatter: function () {
              const present = this.series.chart.series[0].data[this.index].y;
              const absent = this.series.chart.series[1].data[this.index].y;
              const total = present + absent;
              return '<span style="font-weight: 600; color: #0caf60;">Present:</span> ' +
                  Highcharts.numberFormat(present, 0, '.', ',') +
                  '<br/>' +
                  '<span style="font-weight: 600; color: #ff3a6e;">Absent:</span> ' +
                  Highcharts.numberFormat(absent, 0, '.', ',') + '<br/>' +
                  '<span style="font-weight: 600;">Total:</span> ' +
                  Highcharts.numberFormat(total, 0, '.', ',');
            }
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                rotation: -90,
                align: 'right',
                verticalAlign: 'middle',
                y: 10,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 0, '.', ',');
                }
              }
            }
          },
          series: [
            {
              name: 'Present',
              color: '#0caf60',
              data: presentData
            },
            {
              name: 'Absent',
              color: '#ff3a6e',
              data: absentData
            }
          ],
          drilldown: {
            series: drilldownSeries
          }
        });
      }
    },

    //Employee attendance for Today
    getTodayAttendance() {
      const data = new FormData();
      data.append("function", "getTodayAttendance");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.todayAttendanceData = res.data.data;
              // Render the chart with the dynamic data
              this.renderAttendanceChartToday(res.data.data);
            } else {
              console.error("Failed to fetch attendance data");
              // Optionally show an error message to the user
            }
          })
          .catch((e) => {
            console.error("Error fetching attendance data:", e);
            // Optionally show an error message to the user
          });
    },
    renderAttendanceChartToday(attendanceData) {
      if (document.getElementById('TodayAttendanceContainer')) {
        // Convert string values to numbers to ensure proper calculations
        const totalEmployees = Number(attendanceData.totalEmployees);
        const presentEmployees = Number(attendanceData.summary.present);
        const absentEmployees = Number(attendanceData.summary.absent);

        // Create a chart configuration using the dynamic data
        Highcharts.chart('TodayAttendanceContainer', {
          chart: {
            type: 'column'
          },
          title: {
            text: null
          },
          subtitle: {
            text: 'Click the columns to view department-wise attendance.'
          },
          accessibility: {
            announceNewData: {
              enabled: true
            },
            point: {
              valueSuffix: '%'
            }
          },
          xAxis: {
            type: 'category',
            title: {
              text: 'Attendance Status'
            }
          },
          yAxis: {
            title: {
              text: 'Number of Employees'
            }
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                rotation: -90,
                align: 'right',
                verticalAlign: 'middle',
                y: 10,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 0, '.', ',');
                }
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: ' +
                '<b>{point.y} ({(point.y / ' + totalEmployees + ' * 100).toFixed(1)}%)</b> of total<br/>'
          },

          // Use the dynamic series data from the API response
          series: attendanceData.chartData.series.map(series => {
            // Convert string 'y' values to numbers
            return {
              ...series,
              data: series.data.map(item => ({
                ...item,
                y: Number(item.y)
              }))
            };
          }),

          // Use the dynamic drilldown data
          drilldown: {
            series: attendanceData.chartData.drilldown.series
          }
        });
      }
    },

    //Staff Turnover by Department
    getStaffTurnover() {
      const data = new FormData();
      data.append("function", "getStaffTurnover");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              this.staffTurnoverData = res.data.data;
              // Render the chart with the dynamic data
              this.renderStaffTurnoverChart(res.data.data);
            } else {
              console.error("Failed to fetch staff turnover data");
              // Optionally show an error message to the user
            }
          })
          .catch((e) => {
            console.error("Error fetching staff turnover data:", e);
            // Optionally show an error message to the user
          });
    },
    renderStaffTurnoverChart(turnoverData) {
      if (document.getElementById('NewContainer')) {
        // Create a chart configuration using the dynamic data
        Highcharts.chart('NewContainer', {
          chart: {
            type: 'bar'
          },
          title: {
            text: null
          },
          subtitle: {
            text: turnoverData.chartData.subtitle
          },
          xAxis: {
            categories: turnoverData.chartData.xAxis.categories,
            title: {
              text: turnoverData.chartData.xAxis.title
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Number of Employees'
            }
          },
          legend: {
            enabled: true
          },
          tooltip: {
            shared: true,
            pointFormat: '<b>{series.name}: {point.y}</b>'
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 0, '.', ',');
                }
              },
              stacking: 'normal'
            }
          },
          // Use dynamic series data from API response
          series: turnoverData.chartData.series,
          caption: {
            text: `<div style="text-align: right; font-size: 16px; font-weight: bold; color: #000;">Total New Hires: ${turnoverData.totals.hires} | Total Exits: ${turnoverData.totals.exits}</div>`,
            useHTML: true
          }
        });
      }
    },

    //Nature Of exits data
    getNatureOfExits() {
      const data = new FormData();
      data.append("function", "getNatureOfExits");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.natureOfExitData = res.data.data;
              // Render the chart with the dynamic data
              this.renderNatureOfExitsChart(res.data.data);
            } else {
              console.error("Failed to fetch nature of exits data");
              // Optionally show an error message to the user
            }
          })
          .catch((e) => {
            console.error("Error fetching nature of exits data:", e);
            // Optionally show an error message to the user
          });
    },
    renderNatureOfExitsChart(exitsData) {
      if (document.getElementById('ExitChart')) {
        // Handle cases where the API returns empty data
        let seriesData = [];
        let drilldownSeries = [];

        // Check if API provided chart data directly
        if (exitsData.chartData.series[0].data.length > 0) {
          // Use the chart data provided by the API
          seriesData = exitsData.chartData.series[0].data;
          drilldownSeries = exitsData.chartData.drilldown.series;
        } else {
          // Create chart data from the byCategory data
          seriesData = Object.entries(exitsData.data.byCategory).map(([name, value]) => {
            return {
              name: name,
              y: value,
              drilldown: name.toLowerCase()
            };
          });

          // If there's byDepartment data, create drilldown series
          if (exitsData.data.byDepartment && exitsData.data.byDepartment.length > 0) {
            // Process departmental data for drilldown
            // This assumes a specific structure - adjust as needed based on your actual data
            drilldownSeries = Object.keys(exitsData.data.byCategory).map(category => {
              const categoryLower = category.toLowerCase();
              const deptData = exitsData.data.byDepartment
                  .filter(item => item.exitReason === category)
                  .map(item => [item.departmentName, item.count]);

              return {
                id: categoryLower,
                name: `${category} - Department Breakdown`,
                data: deptData
              };
            });
          }
        }

        // Create chart configuration with the dynamic data
        Highcharts.chart('ExitChart', {
          chart: {
            type: 'pie'
          },
          title: {
            text: 'Nature of Exits'
          },
          subtitle: {
            text: `Click on a category to view department-wise breakdown (${exitsData.period.startDate} to ${exitsData.period.endDate})`
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y}'
              }
            }
          },
          series: [{
            name: 'Exits',
            colorByPoint: true,
            data: seriesData
          }],
          drilldown: {
            series: drilldownSeries
          }
        });
      }
    },

    //Nature Of entries
    getNatureOfEntries() {
      const data = new FormData();
      data.append("function", "getNatureOfEntries");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.natureOfEntryData = res.data.data;
              // Render the chart with the dynamic data
              this.renderNatureOfEntriesChart(res.data.data);
            } else {
              console.error("Failed to fetch nature of entries data");
              // Optionally show an error message to the user
            }
          })
          .catch((e) => {
            console.error("Error fetching nature of entries data:", e);
            // Optionally show an error message to the user
          });
    },
    renderNatureOfEntriesChart(entriesData) {
      if (document.getElementById('EntryChart')) {
        // Define variables to hold our chart data
        let seriesData = [];
        let drilldownSeries = [];
        let subtitle = 'Click on a category to view department-wise breakdown';
        let period = '';

        // Handle different possible data structures from API
        if (entriesData.chartData && entriesData.chartData.series) {
          // Use chart data directly from API if available
          seriesData = entriesData.chartData.series[0]?.data || [];
          drilldownSeries = entriesData.chartData.drilldown?.series || [];

          // Check if we have period information to enhance the subtitle
          if (entriesData.period) {
            if (entriesData.period.startDate && entriesData.period.endDate) {
              period = ` (${entriesData.period.startDate} to ${entriesData.period.endDate})`;
            } else if (entriesData.period.year && entriesData.period.monthName) {
              period = ` (${entriesData.period.monthName} ${entriesData.period.year})`;
            }
            subtitle += period;
          }
        } else if (entriesData.data) {
          // Similar structure to exits data, format accordingly
          if (entriesData.data.byCategory) {
            seriesData = Object.entries(entriesData.data.byCategory).map(([name, value]) => {
              return {
                name: name,
                y: value,
                drilldown: name.toLowerCase().replace(/\s+/g, '_')
              };
            });
          }

          // Process departmental breakdown data if available
          if (entriesData.data.byDepartment && entriesData.data.byDepartment.length > 0) {
            // Process department data for each category
            const categories = Object.keys(entriesData.data.byCategory || {});
            drilldownSeries = categories.map(category => {
              const categoryId = category.toLowerCase().replace(/\s+/g, '_');
              const deptData = entriesData.data.byDepartment
                  .filter(item => item.entryType === category || item.hireType === category)
                  .map(item => [item.departmentName, item.count]);

              return {
                id: categoryId,
                name: `${category} - Department Breakdown`,
                data: deptData
              };
            });
          }
        } else {
          // Fallback - use the sample data as a placeholder
          console.warn("API response structure does not match expected format. Using default data.");
          seriesData = [
            {name: 'Direct Recruitment', y: 0, drilldown: 'direct'},
            {name: 'Transfers In', y: 0, drilldown: 'transfers_in'},
            {name: 'Rehired', y: 0, drilldown: 'rehired'},
            {name: 'Other', y: 0, drilldown: 'other'}
          ];
          drilldownSeries = [];
        }

        // Create chart configuration with the dynamic data
        Highcharts.chart('EntryChart', {
          chart: {
            type: 'pie'
          },
          title: {
            text: 'Nature of New Hires'
          },
          subtitle: {
            text: subtitle
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y}'
              }
            }
          },
          series: [{
            name: 'New Hires',
            colorByPoint: true,
            data: seriesData
          }],
          drilldown: {
            series: drilldownSeries
          }
        });
      }
    },


    //Gender comparison
    getGenderComparison() {
      const data = new FormData();
      data.append("function", "getGenderComparison");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.genderComparisonData = res.data.data;
              // Render the chart with the dynamic data
              this.renderGenderComparisonChart(res.data.data);
            } else {
              console.error("Failed to fetch gender comparison data");
              // Optionally show an error message to the user
            }
          })
          .catch((e) => {
            console.error("Error fetching gender comparison data:", e);
            // Optionally show an error message to the user
          });
    },
    renderGenderComparisonChart(genderData) {
      if (document.getElementById('GenderContainer')) {
        // Get the total number of employees
        const totalEmployees = genderData.totalEmployees;

        // Create chart configuration using the dynamic data
        Highcharts.chart('GenderContainer', {
          chart: {
            type: 'pie'
          },
          title: {
            text: null
          },
          subtitle: {
            text: genderData.chartData.subtitle || 'Click the slices to view department distribution.'
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          plotOptions: {
            series: {
              borderRadius: 5,
              dataLabels: [
                {
                  enabled: true,
                  distance: 15,
                  format: '{point.name}: {point.y}'
                },
                {
                  enabled: true,
                  distance: '-30%',
                  filter: {
                    property: 'percentage',
                    operator: '>',
                    value: 5
                  },
                  format: '{point.y}',
                  style: {
                    fontSize: '0.9em',
                    textOutline: 'none'
                  }
                }
              ]
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: ' +
                '<b>{point.y} of {point.total}</b><br/>' +
                '<span>({point.percentage:.1f}%)</span>'
          },
          // Use the series data from the API response
          series: genderData.chartData.series,
          // Use the drilldown data from the API response
          drilldown: {
            series: genderData.chartData.drilldown.series
          }
        });
      }
    },

    //Distribution of Employees with Disabilities
    getDisabilityDistribution() {
      const data = new FormData();
      data.append("function", "getDisabilityDistribution");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.disabilityDistribution = res.data.data;
              // Render the chart with the dynamic data
              this.renderDisabilityDistributionChart(res.data.data);
            } else {
              console.error("Failed to fetch disability distribution data");
              // Optionally show an error message to the user
            }
          })
          .catch((e) => {
            console.error("Error fetching disability distribution data:", e);
            // Optionally show an error message to the user
          });
    },
    renderDisabilityDistributionChart(disabilityData) {
      if (document.getElementById('disabilityChart')) {
        // Variables to hold our chart data
        let seriesData = [];
        let drilldownSeries = [];
        let subtitle = 'Click to see department-wise distribution';

        // Handle different possible data structures based on patterns seen in other charts
        if (disabilityData.chartData) {
          // Use chart data directly from API if available in the expected format
          if (disabilityData.chartData.series && disabilityData.chartData.series.length > 0) {
            seriesData = disabilityData.chartData.series[0].data || [];
          }

          if (disabilityData.chartData.drilldown && disabilityData.chartData.drilldown.series) {
            drilldownSeries = disabilityData.chartData.drilldown.series;
          }

          // Get subtitle if provided
          if (disabilityData.chartData.subtitle) {
            subtitle = disabilityData.chartData.subtitle;
          }
        }
        // Try alternative data structures if chartData isn't present or is empty
        else if (disabilityData.data) {
          // If it has a byGender or similar structure like the gender comparison endpoint
          if (disabilityData.data.byGender) {
            const total = disabilityData.totalEmployees ||
                (disabilityData.data.byGender.Male + disabilityData.data.byGender.Female);

            seriesData = Object.entries(disabilityData.data.byGender).map(([gender, count]) => {
              return {
                name: gender,
                y: count,
                drilldown: gender.toLowerCase(),
                total: total
              };
            });

            // Handle department breakdown if available
            if (disabilityData.data.byDepartment) {
              drilldownSeries = Object.entries(disabilityData.data.byDepartment).map(([gender, deptData]) => {
                return {
                  id: gender.toLowerCase(),
                  name: `${gender} Employees with Disabilities - Department Breakdown`,
                  dataLabels: {
                    format: '{point.name}: {point.y} ({point.percentage:.1f}%)'
                  },
                  data: deptData
                };
              });
            }
          }
          // Handle other possible structures
          else if (disabilityData.distribution) {
            // Another possible structure based on patterns
            seriesData = Object.entries(disabilityData.distribution).map(([key, value]) => {
              return {
                name: key,
                y: value,
                drilldown: key.toLowerCase()
              };
            });
          }
        }

        // If we still don't have data, use empty arrays (chart will show "No data to display")
        if (seriesData.length === 0) {
          console.warn("No valid data found for disability chart. Check API response format.");
        }

        // Create chart configuration using the dynamic data
        Highcharts.chart('disabilityChart', {
          chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false
          },
          title: {
            text: null
          },
          subtitle: {
            text: subtitle
          },
          accessibility: {
            point: {
              valueSuffix: ''
            }
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y} ({point.percentage:.1f}%)'
              },
              startAngle: -90,
              endAngle: 90,
              center: ['50%', '75%'],
              size: '110%'
            }
          },
          series: [{
            name: 'Gender',
            colorByPoint: true,
            innerSize: '50%',
            data: seriesData
          }],
          drilldown: {
            series: drilldownSeries
          }
        });
      }
    }


  }

}
</script>

